var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuturesMain = function SvgFuturesMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22h14a3 3 0 0 0 3-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v12H2v4a3 3 0 0 0 3 3m1-5v2a1 1 0 1 1-2 0v-2zm2 3V4h12v15a1 1 0 0 1-1 1zm10-5H9.852v2H18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.706 6.527h5.9v5.9h-1.805V9.608L11.4 14.01l-1.277-1.277 4.402-4.401h-2.82z",
    clipRule: "evenodd"
  })));
};
export default SvgFuturesMain;